var exports = {
  "advantage": "x7f9a0e16--15c606--advantage",
  "icon": "x7f9a0e16--15c606--icon",
  "content": "x7f9a0e16--15c606--content",
  "title": "x7f9a0e16--15c606--title",
  "description": "x7f9a0e16--15c606--description",
  "time": "x7f9a0e16--15c606--time",
  "reliability": "x7f9a0e16--15c606--reliability",
  "wishes": "x7f9a0e16--15c606--wishes",
  "price": "x7f9a0e16--15c606--price",
};

module.exports = exports;
